<template>
    <block-section>
        <breadcrumb />
        <layout-split :headline="texts.title" reverse>
            <template v-slot:primary>
                <text-headline-secondary class="description">
                    {{ texts.product_information_title }}
                </text-headline-secondary>

                <block-travel-information />
            </template>

            <template v-slot:secondary>
                <form @submit.prevent="nextStep">
                    <div class="group">
                        <template v-if="availableProductVariants.length > 1">
                            <text-headline-secondary>
                                {{ texts.product_variant_title }}
                            </text-headline-secondary>

                            <field-retiree-product-variants
                                v-if="availableProductVariants.length > 1"
                            />
                        </template>

                        <text-headline-secondary v-else>
                            {{ selectedName }}
                        </text-headline-secondary>

                        <p>{{ selectedDescription }}</p>
                    </div>

                    <div class="group">
                        <text-headline-secondary>
                            {{ texts.validity_span_title }}
                        </text-headline-secondary>

                        <p>
                            <named-value :name="texts.validity_period_info_title">
                                <span v-html="texts.validity_span_description"></span>
                            </named-value>
                        </p>
                        
                        <field-retiree-date-range />
                    </div>

                    <text-button
                        class="next-button"
                        type="submit"
                        :disabled="!isStepValid"
                    >
                        {{ $t("page_new_retiree_ticket.next_step_button") }}
                    </text-button>
                </form>
            </template>
        </layout-split>
    </block-section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TextButton from "@/components/elements/TextButton";
import BlockTravelInformation from "@/components/blocks/BlockTravelInformation";
import FieldRetireeDateRange from "@/components/fields/FieldRetireeDateRange";
import FieldRetireeProductVariants from "@/components/fields/FieldRetireeProductVariants";
import paths from "@/router/paths";

export default {
    components: {
        TextButton,
        BlockTravelInformation,
        FieldRetireeDateRange,
        FieldRetireeProductVariants
    },
    computed: {
        texts() {
            return this.$t("page_new_retiree_ticket");
        },
        selectedName() {
            if (!this.selectedProductVariant) return null;
            return this.selectedProductVariant.texts[this.$i18n.locale].name;
        },
        selectedDescription() {
            if (!this.selectedProductVariant) return null;
            return this.selectedProductVariant.texts[this.$i18n.locale]
                .salesText;
        },
        ...mapGetters({
            availableProductVariants:
                "products/retireeticket/getAvailableProductVariants",
            selectedProductVariant:
                "products/retireeticket/getSelectedProductVariant",
            isStepValid: "flow/isStepValid",
            shipmentDays: "system/snailmailShipmentDelayDayCount"
        })
    },
    created() {
        this.initFlow();
    },
    methods: {
        ...mapActions({
            nextStep: "flow/gotoNextStep"
        }),
        async initFlow() {
            const productId = parseInt(this.$route.query.productId);
            const municipalityId = parseInt(this.$route.query.municipalityId);

            try {
                if (!municipalityId || isNaN(municipalityId)) {
                    throw new Error("municipalityId missing");
                }
                await this.$store.dispatch("flow/startRetireeTicketFlow", {
                    municipalityId,
                    productVariantId:
                        productId && !isNaN(productId) ? productId : undefined
                });
            } catch (e) {
                return this.$router.replace(paths.retireeProducts);
            }
        }
    }
};
</script>

<style scoped lang="scss">
.group {
    margin-bottom: 2rem;
}
</style>
